<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-2"
          medium
          >{{ dIcon }}</v-icon
        >
        {{ dTitle }}
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-title class="ma-0 pb-0">
        <v-flex xs6>
          <v-text-field
            class="ma-0 mb-4 pa-0 mx-1"
            clearable
            v-model="$store.state.storeImageDatabase.search"
            append-icon="mdi-magnify"
            :label="$t('dataGridSearchLabel')"
            single-line
            hide-details
            @keyup.enter="getSearch"
            @click:append="getSearch"
            @click:clear="
              $nextTick(() => {
                $store.state.storeImageDatabase.search = '';
                getSearch();
              })
            "
          ></v-text-field>
        </v-flex>
        <v-flex
          xs6
          class="ma-0 pa-0"
          v-show="dType == G_IMAGE_DATABASE_TYPE_STICKERS && mode == 'live'"
        >
          <v-select
            class="pa-0 mx-1"
            v-model="$store.state.storeImageDatabase.lang"
            :items="langSelect"
            item-text="title"
            item-value="query"
            :label="$t('dialogImageDatabaseSelectionStickersType')"
            @change="getSearch"
          ></v-select>
        </v-flex>
        <v-flex
          xs6
          class="ma-0 pa-0"
          v-show="dType == G_IMAGE_DATABASE_TYPE_STICKERS && mode == 'live'"
        >
          <v-btn
            @click="handlerAddNewCustomSticker"
            color="accent"
            class="mx-1 mb-1 elevation-0"
            ><v-icon class="mr-1">mdi-file-upload-outline</v-icon
            ><span v-if="$vuetify.breakpoint.mdAndUp">{{
              $t("dialogImageDatabaseSelectionStickersTypeCustomBtnLong")
            }}</span>
            <span v-else>{{
              $t("dialogImageDatabaseSelectionStickersTypeCustomBtn")
            }}</span>
            <input
              id="addNewCustomStickerInput"
              class="d-none"
              type="file"
              accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
              @change="addNewCustomSticker"
            />
          </v-btn>
        </v-flex>
        <v-flex xs6>
          <v-select
            v-show="
              dType == G_IMAGE_DATABASE_TYPE_BACKGROUNDS ||
              dType == G_IMAGE_DATABASE_TYPE_PATTERNS ||
              dType == G_IMAGE_DATABASE_TYPE_STICKERS ||
              dType == G_IMAGE_DATABASE_TYPE_FRAMES
            "
            class="pa-0 mx-1"
            v-model="$store.state.storeImageDatabase.order"
            :items="orderType"
            item-text="title"
            item-value="query"
            :label="$t('dialogImageDatabaseSelectionOrderBy')"
            @change="getSearch"
          ></v-select>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-container fluid class="py-0" v-if="allowReplace === undefined">
          <v-layout row class="px-1">
            <v-btn
              v-show="$store.state.storeImageDatabase.category != '/'"
              text
              outlined
              small
              rounded
              elevation-0
              color="accent"
              class="mx-1 mb-1"
              @click="
                $store.state.storeImageDatabase.category = '/';
                getSearch();
              "
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-flex
              v-for="(item, index) in $store.state.storeImageDatabaseCategory
                .imageDatabaseCategory"
              :key="index"
              :id="item.id"
              class="mr-1 mb-1"
            >
              <v-btn
                :text="$store.state.storeImageDatabase.category != item.title"
                :outlined="
                  $store.state.storeImageDatabase.category != item.title
                "
                small
                rounded
                elevation-0
                color="accent"
                @click="getCategory(item.title)"
                >{{ item.title }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid>
          <v-layout row class="px-1">
            <v-flex
              v-for="(item, index) in $store.state.storeImageDatabase
                .imageDatabase"
              :key="index"
              :id="item.id"
              xs4
              sm3
              lg2
              xl1
            >
              <v-card
                outlined
                class="mx-1 mb-2"
                style="background-color: #fcfcfc"
                :style="
                  item.active
                    ? 'background-color: #EBEBEB'
                    : 'background-color: #D1D0D0'
                "
              >
                <v-card-text class="pa-0">
                  <v-img
                    :src="item.imagePreview"
                    class="ma-1 hover-item"
                    @click="selectedItem(item)"
                  >
                    <span
                      class="pa-1"
                      style="color: white; background-color: gray"
                      v-show="mode == 'edit' && item.client != '/'"
                    >
                      {{ item.client }}
                    </span>
                  </v-img>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0">
        <v-btn
          :disabled="$store.state.storeImageDatabase.page <= 1"
          color="secondary"
          class="elevation-0"
          @click="previousPage"
        >
          <v-icon medium>mdi-arrow-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div>
          {{ $t("msgPage") }} {{ $store.state.storeImageDatabase.page }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="
            $store.state.storeImageDatabase.page >=
            $store.state.storeImageDatabase.last
          "
          color="secondary"
          class="elevation-0"
          @click="nextPage"
        >
          <v-icon medium>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueCookies from "vue-cookies";
import {
  G_IMAGE_DATABASE_TYPE_STICKERS,
  G_IMAGE_DATABASE_TYPE_BACKGROUNDS,
  G_IMAGE_DATABASE_TYPE_PATTERNS,
  G_IMAGE_DATABASE_TYPE_FRAMES,
} from "@/constants";

export default {
  name: "dialog-image-database-live-selection",
  data() {
    return {
      search: "",
      uploadReady: true, // da lahko dodamo 2x isto sliko zapored (za gumb uvozi nalepko)
      initSearch: true,
      langSelect: [
        {
          title: this.$t("dialogImageDatabaseSelectionStickersTypeAll"),
          query: "all",
        },
        {
          title: this.$t("dialogImageDatabaseSelectionStickersTypeImages"),
          query: "/",
        },
        {
          title: this.$t("dialogImageDatabaseSelectionStickersTypeLang"),
          query: "en",
        },
        {
          title: this.$t("dialogImageDatabaseSelectionStickersTypeCurrentLang"),
          query: VueCookies.get("lang"),
        },
      ],
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    dType: {
      type: String,
      required: true,
    },
    dTitle: {
      type: String,
      required: true,
    },
    dIcon: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    order: {
      type: String,
      required: true,
    },
    pageSize: {
      type: Number,
      required: false,
    },
    cIndex: {
      type: Number,
      required: false,
    },
    allowReplace: {
      type: String,
      required: false,
    },
  },
  computed: {
    active: {
      get() {
        if (this.value && this.initSearch) {
          this.resetAll();
          console.log("ACTIVE GET");
        }
        return this.value;
      },
      set: function (value) {
        this.initSearch = true;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handlerAddNewCustomSticker() {
      document.getElementById("addNewCustomStickerInput").click();
    },
    addNewCustomSticker(e) {
      // reset file input fielda, da lahko izeremo 2x enako sliko
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });

      this.$emit("customSticker", e.target.files[0]);
    },
    nextPage() {
      this.$store.dispatch("getImageDatabase", {
        type: this.dType,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: this.mode,
        refresh: "getNext",
      });
    },
    previousPage() {
      this.$store.dispatch("getImageDatabase", {
        type: this.dType,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: this.mode,
        refresh: "getPrevious",
      });
    },
    refresh() {
      this.$store.dispatch("getImageDatabase", {
        type: this.dType,
        client: this.$store.state.storeClient.client.basicSettings.name,
        mode: this.mode,
        refresh: "refresh",
      });
    },
    getSearch() {
      this.$store.commit("imageDatabaseSetAll", {
        page: 1,
        last: 9999999,
        firstQuery: "",
        lastQuery: "",
        category: this.$store.state.storeImageDatabase.category,
        search:
          this.$store.state.storeImageDatabase.search == null
            ? ""
            : this.$store.state.storeImageDatabase.search,
        lang: this.$store.state.storeImageDatabase.lang,
        order: this.$store.state.storeImageDatabase.order,
      });
      this.refresh();
    },
    getCategory(title) {
      console.log(title);
      this.$store.commit("imageDatabaseSetAll", {
        page: 1,
        last: 9999999,
        firstQuery: "",
        lastQuery: "",
        category: title,
        search:
          this.$store.state.storeImageDatabase.search == null
            ? ""
            : this.$store.state.storeImageDatabase.search,
        lang: this.$store.state.storeImageDatabase.lang,
        order: this.$store.state.storeImageDatabase.order,
      });
      this.refresh();
    },
    resetAll() {
      this.$store.state.storeImageDatabase.imageDatabase = [];
      this.pageSize
        ? (this.$store.state.storeImageDatabase.pageSize = this.pageSize)
        : (this.$store.state.storeImageDatabase.pageSize = 30);
      this.$store.state.storeImageDatabase.order = this.order;
      if (this.initSearch) {
        this.initSearch = false;

        this.$store.dispatch("getImageDatabaseCategory", {
          type: this.dType,
          client: this.$store.state.storeClient.client.basicSettings.name,
          mode: this.mode,
        });

        if (this.allowReplace !== undefined) {
          this.$store.state.storeImageDatabase.category = this.allowReplace;
          this.getSearch();
        } else {
          this.$store.commit("imageDatabaseSetAll", {
            page: 1,
            last: 9999999,
            firstQuery: "",
            lastQuery: "",
            category: "/",
            search: "",
            lang: "all",
            order: this.$store.state.storeImageDatabase.order,
          });
          this.refresh();
        }
      }
    },
    selectedItem(item) {
      this.initSearch = true;
      this.$emit(
        "selectedItem",
        this.cIndex !== undefined
          ? Object.assign(item, { cIndex: this.cIndex })
          : item
      ); // dodamo cIndex, če imamo item z določeno podkategorijo
      this.active = false;
    },
  },
  created() {
    this.G_IMAGE_DATABASE_TYPE_STICKERS = G_IMAGE_DATABASE_TYPE_STICKERS;
    this.G_IMAGE_DATABASE_TYPE_BACKGROUNDS = G_IMAGE_DATABASE_TYPE_BACKGROUNDS;
    this.G_IMAGE_DATABASE_TYPE_PATTERNS = G_IMAGE_DATABASE_TYPE_PATTERNS;
    this.G_IMAGE_DATABASE_TYPE_FRAMES = G_IMAGE_DATABASE_TYPE_FRAMES;
  },
};
</script>

<style scoped>
</style>